export const DEFAULT = 'default'
export const RESET = 'reset'
export const SAVE = 'save'
export const REMOVE = 'remove'
export const ACTIVATE = 'activate'
export const DELETE = 'delete'
export const CLEAR = 'clear'
export const CANCEL = 'cancel'
export const UNAVAILABLE = 'unavailable'
export const CUSTOM = 'custom'
export const SAVE_CANCEL = 'saveCancel'
export const SAVE_CLOSE = 'saveClose'
